export default "__VITE_ASSET__Cj_c0m1R__"